import React, { useState, useEffect } from "react";
import {
  Select,
  Grid,
  MenuItem,
  Button,
  CircularProgress,
  Box,
  TextField,
  InputLabel,
  FormControl,
  Typography,
  Pagination, // Importando Pagination
} from "@mui/material";
import ListarNotificacao from "../ListarNotificacao";
import CriarNotificacao from "../CriarNotificacao";

interface GerenciarNotificacaoProps {
  token: string;
  role: "MASTER" | "PARTNER" | "ANALYST";
}

const GerenciarNotificacao: React.FC<GerenciarNotificacaoProps> = ({
  token,
  role,
}) => {
  const [refreshList, setRefreshList] = useState<number>(0);

  const handleNotificationAction = () => {
    // Esta função será chamada tanto por CriarNotificacao quanto por CardNotificacao
    setRefreshList((prev) => prev + 1);
    console.log("Ação em notificação concluída! Atualizando lista...");
  };
  return (
    <Box sx={{ p: 3 }}>
      <Typography gutterBottom variant="h2">
        Notificações
      </Typography>
      <CriarNotificacao
        token={token}
        role={role}
        onNotificationCreated={handleNotificationAction}
      />

      <ListarNotificacao
        key={refreshList}
        token={token}
        role={role}
        refreshTrigger={refreshList}
      />
    </Box>
  );
};

export default GerenciarNotificacao;
